<script lang="ts">
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  const lineHeight = 12;
  const radius = 12;
  const xVal = 0;
</script>

<div data-testid="product-line-filters-skeleton">
  <div class="fizz-inset-horizontal-16 fizz-stack-16">
    <div
      class="fizz-border-top fizz-border-bottom fizz-inset-vertical-16"
      data-testid="filters-header"
    >
      <div class="fizz-flex-row fizz-space-between">
        <div class="fizz-flex-row">
          <Icon width="16" height="16" type="Filter2" />
          <span class="fizz-heading-4">Filters</span>
        </div>
      </div>
    </div>
    <div class="fizz-flex-row fizz-space-between">
      <div class="fizz-flex-row-0">
        <!-- Filter name -->
        <Skeleton animate={true} height={150} width={162}>
          <rect width={110} height={lineHeight} x={xVal} y={30} rx={radius} ry={radius} />
          <rect width={80} height={lineHeight} x={xVal} y={60} rx={radius} ry={radius} />
          <rect width={115} height={lineHeight} x={xVal} y={90} rx={radius} ry={radius} />
        </Skeleton>
        <!-- Filter count -->
        <Skeleton animate={true} height={150} width={110}>
          <rect width={30} height={lineHeight} x={80} y={30} rx={radius} ry={radius} />
          <rect width={28} height={lineHeight} x={82} y={60} rx={radius} ry={radius} />
          <rect width={50} height={lineHeight} x={60} y={90} rx={radius} ry={radius} />
        </Skeleton>
      </div>
    </div>
    <div class="fizz-flex-row fizz-space-between">
      <div class="fizz-flex-row-0">
        <!-- Filter name -->
        <Skeleton animate={true} height={150} width={162}>
          <rect width={110} height={lineHeight} x={xVal} y={30} rx={radius} ry={radius} />
          <rect width={80} height={lineHeight} x={xVal} y={60} rx={radius} ry={radius} />
          <rect width={115} height={lineHeight} x={xVal} y={90} rx={radius} ry={radius} />
          <rect width={115} height={lineHeight} x={xVal} y={120} rx={radius} ry={radius} />
        </Skeleton>
        <!-- Filter count -->
        <Skeleton animate={true} height={150} width={110}>
          <rect width={40} height={lineHeight} x={70} y={30} rx={radius} ry={radius} />
          <rect width={30} height={lineHeight} x={80} y={60} rx={radius} ry={radius} />
          <rect width={35} height={lineHeight} x={75} y={90} rx={radius} ry={radius} />
          <rect width={32} height={lineHeight} x={78} y={120} rx={radius} ry={radius} />
        </Skeleton>
      </div>
    </div>
    <div class="fizz-flex-row fizz-space-between">
      <div class="fizz-flex-row-0">
        <!-- Filter name -->
        <Skeleton animate={true} height={150} width={162}>
          <rect width={110} height={lineHeight} x={xVal} y={30} rx={radius} ry={radius} />
          <rect width={80} height={lineHeight} x={xVal} y={60} rx={radius} ry={radius} />
          <rect width={115} height={lineHeight} x={xVal} y={90} rx={radius} ry={radius} />
          <rect width={115} height={lineHeight} x={xVal} y={120} rx={radius} ry={radius} />
        </Skeleton>
        <!-- Filter count -->
        <Skeleton animate={true} height={150} width={110}>
          <rect width={30} height={lineHeight} x={80} y={30} rx={radius} ry={radius} />
          <rect width={25} height={lineHeight} x={85} y={60} rx={radius} ry={radius} />
          <rect width={45} height={lineHeight} x={65} y={90} rx={radius} ry={radius} />
          <rect width={45} height={lineHeight} x={65} y={120} rx={radius} ry={radius} />
        </Skeleton>
      </div>
    </div>
  </div>
</div>
